<template>
  <base-data-table
    :items="epdsHistories"
    title="EPDS履歴"
    header-icon="mdi-medical-bag"
    :column-widths="['160px', '120px', '110px', '110px', '120px']"
  >
    <template #header-cells>
      <th>回答日時</th>
      <th>週数/月数</th>
      <th>合計点数</th>
      <th>設問10</th>
      <th />
    </template>
    <template #cells="{ row: epdsHistory }">
      <td>{{ epdsHistory.answeredAt }}</td>
      <td>{{ epdsHistory.period }}</td>
      <td>
        {{ epdsHistory.totalScore }}
        <v-chip
          v-if="epdsHistory.result"
          :class="epdsHistory.result === '陽性' ? 'epds-result-chip-positive' : 'epds-result-chip-negative'"
          size="x-small"
          variant="flat"
        >
          {{ epdsHistory.result }}
        </v-chip>
      </td>
      <td>{{ epdsHistory.question10 }}</td>
      <td class="base-data-table-action-cell">
        <v-btn
          color="#3ACAC9"
          variant="outlined"
          size="small"
          @click="$emit('view-detail', epdsHistory)"
        >
          閲覧する
        </v-btn>
      </td>
    </template>
  </base-data-table>
</template>

<script>
import BaseDataTable from "./BaseDataTable.vue";

export default {
  name: "FaceSheetEpdsHistoryTable",
  components: {
    BaseDataTable
  },
  props: {
    epdsHistories: {
      type: Array,
      default: () => []
    }
  },
  emits: ["add-epds", "view-detail"]
};
</script>

<style lang="scss" scoped>
.epds-result-chip-positive {
  margin-left: 4px;
  background-color: #fce8e6;
  color: #c5221f;
  font-weight: bold;
}

.epds-result-chip-negative {
  margin-left: 4px;
  background-color: #f2f2f2;
  color: rgba(0, 0, 0, 0.6);
  font-weight: bold;
}
</style>
